export default {
    GET_CERTIFICATES: 'GET_CERTIFICATES',
    GET_CERTIFICATES_SUCCESS: 'GET_CERTIFICATES_SUCCESS',
    GET_CERTIFICATES_ERROR: 'GET_CERTIFICATES_ERROR',
}